import React, { CSSProperties, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { ModalManager } from '../../models/ModalManager';
import SignInButton from '../SignInButton';
import { ModalBody, ModalHeading } from './common';
import { Routes } from '../../constants';

const handleLaterBtnClick = () => {
  ModalManager.closeModal();
};

const ShouldLoginModal: React.FC = () => {
  const history = useHistory();

  const handleSignInClick = useCallback(() => {
    ModalManager.closeModal();
    history.push(Routes.auth);
  }, [history]);

  return (
    <ModalBody>
      <ModalHeading>Avoid losing your data</ModalHeading>
      <p>You should sign in so you can check how people voted on your photos when you come back later.</p>
      <SignInButton style={buttonsStyle} onClick={handleSignInClick} />
      <button className={'nes-btn'} style={buttonsStyle} onClick={handleLaterBtnClick}>
        I'm ok with losing my data
      </button>
    </ModalBody>
  );
};

const buttonsStyle: CSSProperties = {
  margin: '20px',
};

export default ShouldLoginModal;
